import { fg } from '@atlaskit/platform-feature-flags';
import { fetch } from '@atlassian/eoc-fetch';

import { type MuteResponse, type QuietHoursResponse } from '../../common/types';

const getTargetAccountIdSuffix = (targetAccountId: string | null | undefined) => {
	if (fg('jsm_admin_access_user_notification_settings')) {
		return targetAccountId ? `?targetAccountId=${targetAccountId}` : '';
	}
};

export const getMuteDetail = (targetAccountId: string | null | undefined) =>
	fetch<MuteResponse>(`/v1/users/notifications/mute${getTargetAccountIdSuffix(targetAccountId)}`);

export const getQuietHoursDetail = (targetAccountId: string | null | undefined) =>
	fetch<QuietHoursResponse>(
		`/v1/users/quiet-hours/details${getTargetAccountIdSuffix(targetAccountId)}`,
	);
